import { FormattedMessage } from 'react-intl'
import type { ReactNode } from 'react'
import FormatDateTime from 'components/utils/Formatters/FormatDateTime'

interface Props {
  credits: number
  nights: number
  date: string
  tier: string
}

function renderBold(chunks: ReactNode) {
  return <strong key="bold">{chunks}</strong>
}

function LoyaltyRewardChoiceTierProgress({ credits, nights, date, tier }: Props) {
  if (credits <= 0 && nights <= 0) {
    return <FormattedMessage
      id="Q9vq6ED7vhwJJZN9nHPt"
      defaultMessage="You have enough Status Credits and nights to unlock {tier} Status."
      description="Double rewards choice progress when both requirements for the next tier have been met"
      values={{ tier }}
    />
  }

  const formattedDate = <FormatDateTime value={date} day="numeric" month="short" year="numeric" />
  if (credits > 0 && nights > 0) {
    return <FormattedMessage
      id="c3X-zdvOfNX736jlQbWb"
      defaultMessage="You need <bold>{credits, number} Status Credits</bold> & <bold>{nights, number} nights</bold> by {date} to unlock {tier} Status."
      description="Double rewards choice progress when both status credits and nights are needed to reach the next tier"
      values={{ credits, nights, date: formattedDate, tier, bold: renderBold }}
    />
  }
  if (credits > 0) {
    return <FormattedMessage
      id="roxNoQDQbNkWM8wl7yZq"
      defaultMessage="You need <bold>{credits, number} Status Credits</bold> by {date} to unlock {tier} Status."
      description="Double rewards choice progress when only status credits are needed to reach the next tier"
      values={{ credits, date: formattedDate, tier, bold: renderBold }}
    />
  }
  return <FormattedMessage
    id="G4GWCEBh-JxBt6p5IjEQ"
    defaultMessage="You need <bold>{nights, number} nights</bold> by {date} to unlock {tier} Status."
    description="Double rewards choice progress when only nights are needed to reach the next tier"
    values={{ nights, date: formattedDate, tier, bold: renderBold }}
  />
}

export default LoyaltyRewardChoiceTierProgress
